import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'med-empty-stub-component',
    template: ''
})
export class EmptyStubComponent {}
